module.exports = __webpack_public_path__ + "img/3.13f3aea4.png";